/*
 * <cc-blog-slider> — mobile-only slider for the Blog posts section.
 * Desktop: children stay in the theme's .grid (this element is display:contents-agnostic).
 * Mobile: the .cc-blog-slider__viewport becomes a native scroll-snap slider (CSS);
 *         this element adds prev/next arrows and dots and keeps them in sync with scroll.
 * Attributes: data-no-arrows, data-no-dots (opt out).
 * Theme-editor safe: connected/disconnected callbacks build and tear down cleanly.
 */
(function () {
  var GAP = 16; // must match .cc-blog-slider__viewport gap in custom.css

  if (customElements.get('cc-blog-slider')) return;

  class CcBlogSlider extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.cc-blog-slider__viewport');
      if (!this.viewport) return;
      this.cards = Array.prototype.slice.call(this.viewport.children);
      if (this.cards.length < 2) return;

      this._built = [];
      this.mq = window.matchMedia('(max-width: 749px)');
      this._sync = this._sync.bind(this);
      this._onScroll = this._onScroll.bind(this);

      if (this.mq.addEventListener) {
        this.mq.addEventListener('change', this._sync);
      } else if (this.mq.addListener) {
        this.mq.addListener(this._sync); // older Safari
      }
      this._sync();
    }

    disconnectedCallback() {
      if (this.mq) {
        if (this.mq.removeEventListener) this.mq.removeEventListener('change', this._sync);
        else if (this.mq.removeListener) this.mq.removeListener(this._sync);
      }
      this._teardown();
    }

    _sync() {
      this._teardown();
      if (!this.mq || !this.mq.matches) return;
      if (!this.hasAttribute('data-no-arrows')) this._buildArrows();
      if (!this.hasAttribute('data-no-dots')) this._buildDots();
      this.viewport.addEventListener('scroll', this._onScroll, { passive: true });
      this._onScroll();
    }

    _teardown() {
      if (this.viewport) this.viewport.removeEventListener('scroll', this._onScroll);
      if (this._built) this._built.forEach(function (el) { el.remove(); });
      this._built = [];
      this.dots = null;
      this.prevBtn = null;
      this.nextBtn = null;
    }

    _step() {
      return this.cards[0].getBoundingClientRect().width + GAP;
    }

    _index() {
      var step = this._step();
      if (!step) return 0;
      return Math.round(this.viewport.scrollLeft / step);
    }

    _icon(dir) {
      var d = dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7';
      return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
        '<path d="' + d + '" stroke="currentColor" stroke-width="1.5" ' +
        'stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }

    _buildArrows() {
      var self = this;
      ['prev', 'next'].forEach(function (dir) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cc-blog-slider__arrow cc-blog-slider__arrow--' + dir;
        b.setAttribute('aria-label', dir === 'prev' ? 'Previous slide' : 'Next slide');
        b.innerHTML = self._icon(dir);
        b.addEventListener('click', function () {
          var by = dir === 'prev' ? -self._step() : self._step();
          self.viewport.scrollBy({ left: by, behavior: 'smooth' });
        });
        self.appendChild(b);
        self._built.push(b);
        if (dir === 'prev') self.prevBtn = b; else self.nextBtn = b;
      });
    }

    _buildDots() {
      var self = this;
      var wrap = document.createElement('div');
      wrap.className = 'cc-blog-slider__dots';
      this.dots = this.cards.map(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cc-blog-slider__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function () {
          self.viewport.scrollTo({ left: i * self._step(), behavior: 'smooth' });
        });
        wrap.appendChild(dot);
        return dot;
      });
      this.appendChild(wrap);
      this._built.push(wrap);
    }

    _onScroll() {
      var last = this.cards.length - 1;
      var i = Math.max(0, Math.min(last, this._index()));
      if (this.dots) {
        this.dots.forEach(function (dot, k) { dot.classList.toggle('is-active', k === i); });
      }
      if (this.prevBtn) this.prevBtn.hidden = i <= 0;
      if (this.nextBtn) this.nextBtn.hidden = i >= last;
    }
  }

  customElements.define('cc-blog-slider', CcBlogSlider);
})();
